import React from "react";

import "./tools.scss";

import {ElevationProfileButton} from "./elevation-profile/elevation-profile-button";
import {MeasurementButtons} from "./measurement/measurement-buttons";
import {ToolsConfiguration} from "../../config/tools-configuration";
import {IAppStore, withStore} from "../../stores/abstract-app-store";


interface ToolsProps {
    config: ToolsConfiguration;
    small?: boolean;
    store?: IAppStore; // this is injected by withStore
}

class ToolsBase extends React.Component<ToolsProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    widgetKey = "tools";
    constructor(props: ToolsProps) {
        super(props);
        this.state = {
            viewModel: null,
            isLoading: true,
            activeTool: null
        };
        if (typeof this.props.small === "boolean" && this.props.small) {
            this.widgetKey += "-small";
        }
        this.handleClick=this.handleClick.bind(this);
    }
    handleClick(tool: string | null, subTool?: string): void {
        const {store} = this.props;
        this.setState({activeTool: tool});
        if (tool) {
            store?.PopupStore.setDisabled(true);
            store?.uiStore.setActiveTool(tool + ((subTool !== undefined)? "-"+subTool: ""));
        } else {
            store?.PopupStore.setDisabled(false);
            store?.uiStore.setActiveTool("");
        }
    }
    componentDidMount(): void {
    }

    componentWillUnmount(): void {
        const {store} = this.props;
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
        store?.uiStore.removeWidget(this.widgetKey);
    }

    render(): JSX.Element | null {
        const {small, store} = this.props;
        const {activeTool} = this.state;

        if (!store) {
            return null;
        }

        return (
            <div className={"geo-tools-wrapper"}>
                <MeasurementButtons
                    active={activeTool==="measurement"}
                    uiStore={store.uiStore}
                    onClick={this.handleClick}
                    small={small}/>
                <ElevationProfileButton
                    active={activeTool==="profile"}
                    uiStore={store.uiStore}
                    onClick={this.handleClick}
                    small={small}/>
            </div>
        );
    }
}

export const Tools = withStore(ToolsBase);
